import React from "react";
import { Button } from "components/Core/Button/Button";
import { View } from "react-native";
import { useTranslation } from "react-i18next";
import { theme } from "@clearabee/ui-library-native";
import { useQuestionContext } from "lib/providers/questionProvider";
import { FormState } from "../SkipBags.validation";

export const IsPaid = (): React.ReactElement => {
  const [translate] = useTranslation();
  const context = useQuestionContext<FormState>();
  const isPaid = context.get("isPaid");

  return (
    <View
      style={{
        marginVertical: theme.spacing.large,
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <Button
        size="medium"
        color="warning"
        styles={{
          marginRight: theme.spacing.xlarge2,
        }}
        onClick={() => {
          (isPaid === "No"
            ? context.reset({ type: "COLLECTIONONLYSKIPBAGS", isPaid: "Yes" })
            : context.set("isPaid", "Yes")
          ).open("refAndPostcode");
        }}
      >
        {translate("common.yes")}
      </Button>
      <Button
        size="medium"
        color="warning"
        onClick={() => {
          (isPaid === "Yes"
            ? context.reset({ type: "COLLECTIONONLYSKIPBAGS", isPaid: "No" })
            : context.set("isPaid", "No")
          ).open("products");
        }}
      >
        {translate("common.no")}
      </Button>
    </View>
  );
};
